import { Grid } from '@mui/material';
import React from 'react';
import componentConstants from '../../../core-utils/messages/componentConstants';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';

export interface ResetInstructionsInfoProps {
  email: string;
}

const ResetInstructionsInfo: React.FC<ResetInstructionsInfoProps> = ({
  email,
}) => {
  //constants
  const constants =
    componentConstants.ORGANISMS.RESET_PASSWORD.RESET_INSTRUCTIONS;

  return (
    <Grid container style={{ width: '405px' }}>
      <Grid style={{ marginBottom: '16px' }}>
        <Typography
          textColor={patientAccessTheme.palette.text.highemphasis}
          fontSize="24px"
          lineHeight="29px"
          fontType="semiBold"
        >
          {constants.TITLE}
        </Typography>
      </Grid>
      <Grid container style={{ marginBottom: '12px' }}>
        <Grid>
          <Typography
            textColor={patientAccessTheme.palette.text.mediumemphasis}
            fontSize="14px"
            lineHeight="25px"
          >
            {constants.INFO1}
          </Typography>
        </Grid>

        <Grid>
          <Typography
            textColor={patientAccessTheme.palette.text.mediumemphasis}
            fontSize="14px"
            lineHeight="25px"
          >
            <Typography
              textColor={patientAccessTheme.palette.text.highemphasis}
              fontSize="14px"
              lineHeight="23px"
              fontType="medium"
              component="span"
            >
              {email}
            </Typography>
            {constants.INFO2}
          </Typography>
        </Grid>
      </Grid>
      <Grid>
        <Typography
          textColor={patientAccessTheme.palette.text.mediumemphasis}
          fontSize="14px"
          lineHeight="25px"
        >
          {constants.RECEIVE_EMAIL_INFO}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default ResetInstructionsInfo;
